module.exports = __webpack_public_path__ + "static/img/22.49832816.jpg";